<template>
    <section class="section section-lg">
        <div class="container">
            <div class="row row-grid justify-content-center">
                <div class="col-lg-8 text-center">
                    <h2 class="display-3">Do you love this awesome
                        <span class="text-success">Progressive JavaScript Framework?</span>
                    </h2>
                    <p class="lead">Cause if you do, it can be yours for FREE. Hit the button below to navigate to Get Started where you can find the details. Start a new project or give an old project a new setup!</p>
                    <div class="btn-wrapper">
                        <a href="https://vuejs.org/" class="btn btn-primary mb-3 mb-sm-0">Download Vue</a>
                    </div>
                    <div class="text-center">
                        <h4 class="display-4 mb-5 mt-5">Available on these technologies</h4>
                        <div class="row justify-content-center">
                          <div class="col-lg-2 col-4">
                                <a href="https://vuejs.org/" target="_blank" data-toggle="tooltip" data-original-title="Vue.js - The progressive javascript framework">
                                    <img v-lazy="'https://vuejs.org/images/logo.png'" class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://vuejs.org/" target="_blank" data-toggle="tooltip" data-original-title="Vue.js - The progressive javascript framework">
                                    <img v-lazy="'https://vuejs.org/images/logo.png'" class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://vuejs.org/" target="_blank" data-toggle="tooltip" data-original-title="Vue.js - The progressive javascript framework">
                                    <img v-lazy="'https://vuejs.org/images/logo.png'" class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://vuejs.org/" target="_blank" data-toggle="tooltip" data-original-title="Vue.js - The progressive javascript framework">
                                    <img v-lazy="'https://vuejs.org/images/logo.png'" class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://vuejs.org/" target="_blank" data-toggle="tooltip" data-original-title="Vue.js - The progressive javascript framework">
                                    <img v-lazy="'https://vuejs.org/images/logo.png'" class="img-fluid">
                                </a>
                            </div>
                            <div class="col-lg-2 col-4">
                                <a href="https://vuejs.org/" target="_blank" data-toggle="tooltip" data-original-title="Vue.js - The progressive javascript framework">
                                    <img v-lazy="'https://vuejs.org/images/logo.png'" class="img-fluid">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
</style>
